import { Box, Typography, Checkbox, FormControlLabel } from '@mui/material'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'

const FormBox = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '12px',
	marginTop: '24px',
}))

const GroupBox = styled(Box)(() => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: '16px',
	marginLeft: '8px',
}))

const SMS_GROUPS = ['auto', 'AH', 'CH', 'ES', 'JH', 'LM', 'PB']

export default function SmsGroupSelection() {
	const { t } = useTranslation()
	const { control } = useFormContext()

	return (
		<FormBox>
			<Typography variant="h6" color="info" sx={{ marginLeft: '8px' }}>
				{t('SMS Groups')}* :
			</Typography>
			<Controller
				name="selected_groups"
				control={control}
				render={({ field: { onChange, value = [] } }) => (
					<GroupBox>
						{SMS_GROUPS.map((group) => (
							<FormControlLabel
								key={group}
								control={
									<Checkbox
										checked={value.includes(group)}
										onChange={(e) => {
											if (e.target.checked) {
												onChange([...value, group])
											} else {
												onChange(value.filter((g: string) => g !== group))
											}
										}}
									/>
								}
								label={group}
							/>
						))}
					</GroupBox>
				)}
			/>
		</FormBox>
	)
}
